export interface Denounce {
  id: string;
  trackingId: string;
  category: string;
  relationship: string;
  isAnonymous: boolean;
  reporterName?: string;
  reporterEmail?: string;
  reporterPhone?: string;
  reporterCountryCode?: string;
  reporterDocumentType?: string;
  reporterDocumentNumber?: string;
  accusedName: string;
  accusedRole?: string;
  location: string;
  incidentDate: string;
  description: string;
  status: DenounceStatus;
  assignedTo?: string;
  assignedOperator?: DenounceOperator;
  attachments?: DenounceAttachment[];
  messages?: DenounceMessageItem[];
  history?: DenounceStatusHistoryItem[];
  createdAt: string;
  updatedAt: string;
}

export type DenounceStatus = 'RECIBIDA' | 'EN_INVESTIGACION' | 'CONCLUIDA' | 'DESESTIMADA';

export interface DenounceOperator {
  id: string;
  cognitoId: string;
  operatorName: string;
  operatorEmail: string;
  role: DenounceRole;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export type DenounceRole = 'ADMIN' | 'INVESTIGADOR' | 'VISUALIZADOR';

export interface DenounceAttachment {
  id: string;
  referenceType: 'DENOUNCE' | 'MESSAGE';
  referenceId: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  storageKey: string;
  createdAt: string;
}

export interface DenounceMessageItem {
  id: string;
  authorType: 'ADMIN' | 'REPORTER';
  authorId?: string;
  author?: DenounceOperator;
  content: string;
  attachments?: DenounceAttachment[];
  createdAt: string;
}

export interface DenounceStatusHistoryItem {
  id: string;
  oldStatus?: string;
  newStatus: string;
  changedBy?: string;
  changedByOperator?: DenounceOperator;
  notes?: string;
  createdAt: string;
}

export interface DenounceListResponse {
  data: Denounce[];
  total: number;
  page: number;
  limit: number;
}

export interface DenounceFilters {
  status?: string;
  category?: string;
  assignedTo?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
}

export interface DenounceAccessCheck {
  hasAccess: boolean;
  role: DenounceRole | null;
}

export const DENOUNCE_STATUS_LABELS: Record<DenounceStatus, string> = {
  RECIBIDA: 'Recibida',
  EN_INVESTIGACION: 'En investigaci\u00f3n',
  CONCLUIDA: 'Concluida',
  DESESTIMADA: 'Desestimada',
};

export const DENOUNCE_STATUS_COLORS: Record<DenounceStatus, string> = {
  RECIBIDA: '#1565C0',
  EN_INVESTIGACION: '#F9A825',
  CONCLUIDA: '#2E7D32',
  DESESTIMADA: '#757575',
};
